import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { BuscarSolicitud, Solicitud, SolicitudPoliza } from '../../model/solicitud.model';
import { MenuItem, UsuarioPaeonia } from '../../model/menu.model';
import { PolizaSalud } from '../../model/salud.model';
import { Auth } from '../../model/auth.model';
import { BaseApiService } from './base-api.service';
import { Localidad, Provincia, TipoDocumento, TipoVia } from '../../model/poliza.model';

@Injectable({
  providedIn: 'root'
})
export class SegurosApiService extends BaseApiService {

  getSolicitudes(busqueda: BuscarSolicitud): Observable<Array<Solicitud>> {
    const requestBody = {
      nombreAgente: busqueda.nombreAgente,
      fechaEmision: busqueda.fechaEmisionDesde,
      fechaEmisionHasta: busqueda.fechaEmisionHasta,
      codigoCertificado: busqueda.numeroPoliza,
      estadoSolicitud: busqueda.estado,
      documentoTomador: busqueda.documento,
      listaColectivas: busqueda.codigoColectiva ? [busqueda.codigoColectiva] : null
    };
    return this.invocarSeguros<Array<Solicitud>>('POST', 'solicitud/salud', requestBody);
  }

  getDatosSolicitudSalud(solicitud: Solicitud): Observable<SolicitudPoliza<PolizaSalud>> {
    const requestBody = {
      nombreAgente: solicitud.nombreAgente,
      codigoColectivo: solicitud.codigoColectiva,
      codigoCertificado: solicitud.codigoCertificado,
      tipoSolicitud: solicitud.tipoSolicitud,
      estadoSolicitud: solicitud.codigoEstado,
      numeroMovimiento: solicitud.numeroMovimiento
    };
    return this.invocarSeguros<SolicitudPoliza<PolizaSalud>>('POST', 'solicitud/salud/detalle', requestBody);
  }

  getMenuPrivado(): Observable<MenuItem[]> {
    return this.invocarSeguros<MenuItem[]>('GET', 'menu');
  }

  buscarUsuario(codUsuario: string): Observable<UsuarioPaeonia>{
    return this.invocarSeguridad<UsuarioPaeonia>('GET', `usuario/${codUsuario}`, true);
  }

  getDuplicado(numeroPoliza: number, numeroCertificado: number): Observable<string> {
    return this.invocarSeguros<string>('GET', `solicitud/salud/duplicado/${numeroPoliza}/${numeroCertificado}`);
  }

  login(usuario: string, password: string): Observable<Auth> {
    const requestBody = {
      usuario: usuario,
      password: password
    };
    return this.invocarSeguridad<Auth>('POST', 'auth/login', false, requestBody);
  }

  autologin(token: string): Observable<Auth> {
    const requestBody = {
      tokenApp: token
    };
    return this.invocarSeguridad<Auth>('POST', 'auth/autologin', false, requestBody);
  }

  suplantar(usuarioSuplantado: string): Observable<Auth> {
    const requestBody = { usernameSuplantado: usuarioSuplantado };
    return this.invocarSeguridad<Auth>('POST', 'auth/suplantar', true, requestBody);
  }

  finSuplantar(): Observable<Auth> {
    return this.invocarSeguridad<Auth>('GET', 'auth/fin-suplantar', true);
  }

  getTiposDocumento(): Observable<TipoDocumento[]> {
    return this.invocarSeguros<TipoDocumento[]>('GET', 'catalogo/personas/tipos-documento');
  }

  getIdTipoDocumento(documento: string): Observable<number> {
    return this.invocarSeguros<number>('GET', `catalogo/personas/id-tipo-documento/${documento}`);
  }

  getTipoDocumento(documento: string): Observable<TipoDocumento> {
    return this.invocarSeguros<TipoDocumento>('GET', `catalogo/personas/tipo-documento/${documento}`);
  }

  getProvincias(): Observable<Provincia[]> {
    return this.invocarSeguros<Provincia[]>('GET', 'catalogo/domicilios/provincias');
  }

  getTiposVia(): Observable<TipoVia[]> {
    return this.invocarSeguros<TipoVia[]>('GET', 'catalogo/domicilios/tipos-via');
  }

  getLocalidadesPorCP(codigoPostal: string): Observable<Localidad[]> {
    return this.invocarSeguros<Localidad[]>('GET', `catalogo/domicilios/localidades/${codigoPostal}`);
  }
  
}

